export const amountUnitValues = ['yen', 'thousand'] as const;
export type AmountUnit = (typeof amountUnitValues)[number];
export const DEFAULT_AMOUNT_UNIT: AmountUnit = 'yen';

/**
 * 金額を表示単位に応じて変換する
 *
 * 千円単位の場合は切り捨てで整数に変換する
 */
export const convertAmount = (
  amount: number | null | undefined,
  amountUnit?: AmountUnit,
): number | null | undefined => {
  if (amount == null) return amount;
  if (amountUnit === 'thousand') return Math.floor(amount / 1000);
  return amount;
};
